var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8333 19.9167C22.7454 19.9167 25.9167 16.7454 25.9167 12.8333C25.9167 8.92132 22.7454 5.75 18.8333 5.75C14.9213 5.75 11.75 8.92132 11.75 12.8333C11.75 16.7454 14.9213 19.9167 18.8333 19.9167Z",
    stroke: "#989898",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1667 31.25C30.1667 28.2442 28.9726 25.3616 26.8472 23.2361C24.7218 21.1107 21.8391 19.9167 18.8333 19.9167C15.8275 19.9167 12.9449 21.1107 10.8195 23.2361C8.69404 25.3616 7.5 28.2442 7.5 31.25",
    stroke: "#989898",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMy);
export default __webpack_public_path__ + "static/media/my.cb149c6326c1c2df8614f2a6715a4ae1.svg";
export { ForwardRef as ReactComponent };